import { type StyledFontAwesomeIcons } from '@shared/plugin/icons/types';
import {
  faBell as farBell,
  faCreditCard as farCreditCard,
  faCircleQuestion as farCircleQuestion,
  faEnvelopeOpenText as farEnvelopeOpenText,
  faFileLines as farFileLines,
  faGlobe as farGlobe,
  faImage as farImage,
  faPaperPlane as farPaperPlane,
  faPercent as farPercent,
  faShield as farShield,
  faShieldHalved as farShieldHalved,
  faSliders as farSliders,
  faTags as farTags,
  faUsers as farUsers,
  faUser as farUser,
} from '@fortawesome/pro-regular-svg-icons';
import {
  faBell as fasBell,
  faCreditCard as fasCreditCard,
  faCircleQuestion as fasCircleQuestion,
  faEnvelopeOpenText as fasEnvelopeOpenText,
  faFileLines as fasFileLines,
  faGlobe as fasGlobe,
  faImage as fasImage,
  faPaperPlane as fasPaperPlane,
  faPercent as fasPercent,
  faShield as fasShield,
  faShieldHalved as fasShieldHalved,
  faSliders as fasSliders,
  faTags as fasTags,
  faUsers as fasUsers,
  faUser as fasUser,
} from '@fortawesome/pro-solid-svg-icons';

export const instellingenIcons = {
  alerts: { regular: farBell, solid: fasBell },
  emailAuthenticatie: { regular: farShield, solid: fasShield },
  kantoorLogo: { regular: farImage, solid: fasImage },
  mailteksten: { regular: farEnvelopeOpenText, solid: fasEnvelopeOpenText },
  jouwAccount: { regular: farUser, solid: fasUser },
  medewerkers: { regular: farUsers, solid: fasUsers },
  offerteDefaults: { regular: farSliders, solid: fasSliders },
  pakketlabels: { regular: farTags, solid: fasTags },
  provisie: { regular: farPercent, solid: fasPercent },
  risicoscanAlgemeen: { regular: farShieldHalved, solid: fasShieldHalved },
  risicoscanVragen: { regular: farCircleQuestion, solid: fasCircleQuestion },
  sepa: { regular: farCreditCard, solid: fasCreditCard },
  standaardAlertTeksten: { regular: farFileLines, solid: fasFileLines },
  verzendVoorkeur: { regular: farPaperPlane, solid: fasPaperPlane },
  webmodules: { regular: farGlobe, solid: fasGlobe },
} as const satisfies Record<string, StyledFontAwesomeIcons>;
